import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Tooltip } from '@factorialco/f0-react/dist/experimental'
import { InfoCircleLine } from '@factorialco/f0-react/icons/app'
import { Moment } from 'moment'

import i18n from 'modules/core/lib/i18n'

interface Props {
  daysCount?: number | null
  startDate?: Moment | null
}

const TotalDaysActive = ({ daysCount, startDate }: Props) => {
  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 3 }} gap="s2">
      <Box gap="s8">
        <Box flexDirection="row" alignItems="center" gap="s4" height="s24">
          <Text size="200" weight="normal" color="grey800">
            {i18n.t('contract_versions.fix_discontinuous.total_days_active.title')}
          </Text>
          <Tooltip
            description={i18n.t('contract_versions.fix_discontinuous.total_days_active.tooltip')}
          >
            <F0Icon icon={InfoCircleLine} />
          </Tooltip>
        </Box>
        {daysCount ? (
          <Text size="300" weight="medium" color="grey1000">
            {i18n.tp('contract_versions.fix_discontinuous.total_days_active.days_active', {
              count: daysCount,
            })}
          </Text>
        ) : (
          <Text size="300" weight="medium" color="grey600">
            {i18n.t('contract_versions.fix_discontinuous.not_informed')}
          </Text>
        )}
      </Box>
      {startDate && (
        <Text size="200" weight="normal" color="grey800">
          {i18n.t('contract_versions.fix_discontinuous.total_days_active.since', {
            date: startDate.year(),
          })}
        </Text>
      )}
    </Box>
  )
}

export default TotalDaysActive
